export const apiConstatnts = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  ENABLE_AUTHORIZATION: "ENABLE_AUTHORIZATION",
  DISABLE_AUTHORIZATION: "DISABLE_AUTHORIZATION",
  contentType: {
    QUERY_STRING: "application/x-www-form-urlencoded",
    JSON: "application/json",
    FORM_DATA: "multipart/form-data",
  },
  STATE: {
    UPLOADING: "UPLOADING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
  },
};
